import "./RejectedVerification.css";
import React, { Fragment } from "react";
import FormImage from "../../Assets/images/login.png";
import Logout from "../../Controllers/Auth/Logout";
import RejectedVerificationViewModel from "./RejectedVerificationViewModel";
import RequestAccountVerification from "../../Controllers/Auth/RequestAccountVerification";

const RejectedVerification = () => {
  const [navigate, AuthUserObject] = RejectedVerificationViewModel();

  return (
    <div className="main-wrapper rejected-verification-body">
      <div className="rejected-verification-wrapper">
        <div className="container">
          <div className="rejected-verificationbox">
            <div className="rejected-verification-left">
              <img className="img-fluid" src={FormImage} alt="Logo" />
            </div>
            <div className="rejected-verification-right">
              <div className="rejected-verification-right-wrap">
                <h1>Verification Rejected</h1>

                <form>
                  {AuthUserObject?.Count > 3 ? (
                    <Fragment>
                      <div className="form-group">
                        Your account verification is rejected.
                      </div>

                      <div className="form-group">
                        You can contact the concerned authorities for further
                        assistance.
                      </div>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <div className="form-group">
                        Your account verification is rejected.
                      </div>

                      <div className="form-group">
                        You can request for account verification again. Click{" "}
                        <span
                          className="resend-email"
                          onClick={() => {
                            RequestAccountVerification(
                              AuthUserObject?.uid,
                              AuthUserObject?.Count
                            );
                          }}
                        >
                          HERE
                        </span>{" "}
                        to request for account verification.
                      </div>
                    </Fragment>
                  )}

                  <div className="form-group">
                    <button
                      type="button"
                      onClick={async () => {
                        const resp = await Logout();
                        if (resp === true) {
                          navigate("/login");
                        }
                      }}
                      className="btn btn-primary btn-block"
                    >
                      Logout
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RejectedVerification;
